import { BreakdownType } from './JourneyVisitorBreakdown.constant';
import {
  JourneyVisitorBreakdownResponse,
  JourneyVisitorBreakdownRow,
  JourneyVisitorExited,
} from './JourneyVisitorBreakdown.types';

export const getTitle = (breakdownType: BreakdownType, workflowId: number, title: string) => {
  switch (breakdownType) {
    case BreakdownType.VisitorsEntered:
      return `Users who entered ${title} (ID: ${workflowId})`;
    case BreakdownType.VisitorsExitedByRule:
      return `Users who exited ${title} (ID: ${workflowId})`;
    case BreakdownType.VisitorsExited:
      return `Users who finished ${title} (ID: ${workflowId})`;
    default:
      return `Journey Visitor Breakdown for ${title} (ID: ${workflowId})`;
  }
};

export const generateRow = (data: JourneyVisitorBreakdownResponse) => {
  const { getVisitorsBreakdown } = data || {};
  const { visitorsExited = [] } = getVisitorsBreakdown || {};
  return visitorsExited?.map((visitor: JourneyVisitorExited, i) => {
    const { email, userId, enteredAt, exitedAt, exitReason, exitNodeId } = visitor || {};
    const id = (email || userId) as string;
    return {
      id,
      idKey: btoa(id + (Math.random() + 1).toString(36).substring(7)),
      email,
      userId,
      enteredAt,
      exitedAt,
      exitReason,
      exitNodeId,
    } as JourneyVisitorBreakdownRow;
  });
};

export const determineLastPageItems = (
  currentPage: number,
  totalItems: number,
  currentItemsPerPage: number,
) => {
  const totalPages = Math.ceil(totalItems / currentItemsPerPage);
  const lastPageItems = totalItems % currentItemsPerPage;
  if (currentPage >= totalPages) {
    return lastPageItems || currentItemsPerPage;
  }
  return currentItemsPerPage;
};
